import Link from 'next/link';
import { useTheme } from '@forma/forma-ui-theme';
import PageBlock from '@/components/PageBlock';
import analytics from '@/helpers/analytics';

import styles from './cards.module.css';

const lkUrl = process.env.LK_URL;

const Cards = ({ title, items }) => {
  const { lang } = useTheme();

  return (
    <PageBlock variant="filled" className={styles.root} title={title} id="cards">
      <div className={styles.items}>
        {items.map(({ id, title, description, icon }) => (
          <Link
            className={styles.item}
            onClick={() => {
              if (id) analytics.trackYandex(id);
            }}
            href={`${lkUrl}/register?lng=${lang}`}
            key={title}
          >
            <img src={icon} className={styles.icon} width={40} height={40} alt="" />
            <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
            <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
          </Link>
        ))}
      </div>
    </PageBlock>
  );
};

export default Cards;
